import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { wrapper } from './wrapper-helper';
import { formatDate } from 'shared/lib/date';
import { XlsxFile } from './UpdateReferenceData';
import { ReferenceDataValue } from 'entities/document';

interface SelectFileProps {
  files: XlsxFile[];
  currentReferenceData: ReferenceDataValue;
  onSelectFile: (file: XlsxFile) => void;
  notice?: ReactNode;
}

export function SelectFile(props: SelectFileProps) {
  const { t } = useTranslation('reference-data');

  const { files, currentReferenceData, onSelectFile, notice = null } = props;

  return wrapper(
    t('update-file.modal.title'),
    [],
    () => (
      <>
        <table>
          <tbody>
            {files.map((file) => {
              if (file.revisionId === currentReferenceData.fileRevisionId) {
                return (
                  <tr key={file.revisionId} onClick={() => onSelectFile(file)}>
                    <td>
                      <span className="fs-3 text-blue-800">
                        <i className="fa-regular fa-link"></i> {file.filename}
                      </span>
                      <br />
                      <span className="text-gray-700">{t('update-file.current-file')}</span>
                    </td>
                    <td style={{ textAlign: 'end' }}>{formatDate(file.createdAt)}</td>
                  </tr>
                );
              } else {
                return (
                  <tr key={file.revisionId} onClick={() => onSelectFile(file)}>
                    <td>{file.filename}</td>
                    <td style={{ textAlign: 'end' }}>{formatDate(file.createdAt)}</td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </>
    ),
    () => <></>,
    notice
  );
}
